import * as React from 'react';
import { Checkbox as MuiCheckbox, CheckboxProps as MuiCheckboxProps } from '@mui/material';
import {
    checkboxCheckedIcon,
    checkboxUncheckedIcon,
    checkboxIndeterminateIcon,
    FaOptionIcon,
} from '@europrocurement/l2d-icons';
import { useL2DTheme } from '../../../hooks/useL2DTheme';

export type CheckboxProps = MuiCheckboxProps;

export const Checkbox: React.FunctionComponent<CheckboxProps> = function (props: CheckboxProps) {
    const { color = 'primary' } = props;
    const { palette } = useL2DTheme();

    const uncheckedColor = palette.action.disabled;
    const checkedIconColor = palette.checkbox[color as string]?.textColor ?? palette.primary.main;

    const icon = checkboxUncheckedIcon.props.option ? (
        <FaOptionIcon
            icon={checkboxUncheckedIcon.props.option}
            color={uncheckedColor}
            size="lg"
        />
    ) : null;

    const checkedIcon = checkboxCheckedIcon.props.option ? (
        <FaOptionIcon
            icon={checkboxCheckedIcon.props.icon}
            color={checkedIconColor}
            size="lg"
        />
    ) : null;

    const indeterminateIcon = (
        <FaOptionIcon
            icon={checkboxIndeterminateIcon.props.icon}
            color={checkedIconColor}
            size="lg"
        />
    );

    return (
        <MuiCheckbox
            {...props}
            data-testid="checkbox"
            icon={icon}
            checkedIcon={checkedIcon}
            indeterminateIcon={indeterminateIcon}
        />
    );
};
